import {ErrorHandler, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {en_US, NZ_I18N} from 'ng-zorro-antd/i18n';
import {registerLocaleData} from '@angular/common';
import en from '@angular/common/locales/en';
import {HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {FormlyModule} from "@ngx-formly/core";
import {NzMessageService} from "ng-zorro-antd/message";
import {ApplicationModule} from "./application/application.module";
import {FormlyFieldUploadComponent} from "./@formly-aims/formly-field-upload/formly-field-upload.component";
import {GlobalErrorHandler} from "./@core/global-error-handler";
import {NzModalModule} from "ng-zorro-antd/modal";
import {ZorrlyModule} from './@formly/zorrly.module';
import {AdmissionService} from './application/admission.service';

registerLocaleData(en);

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ZorrlyModule,
    FormlyModule.forRoot({
      types: [
        {name: 'upload', component: FormlyFieldUploadComponent, wrappers: []},
        {name: 'prefer-selects', extends: 'multi-select'},
      ]
    }),
    ApplicationModule,
    NzModalModule
  ],
  providers: [
    {provide: NZ_I18N, useValue: en_US},
    NzMessageService,
    AdmissionService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
